import { EVENT_TAGS } from "@/lib/constants";
import { cn } from "@/lib/utils";

interface TagSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
}

export function TagSelect({ value, onChange }: TagSelectProps) {
  const toggleTag = (slug: string) => {
    if (value.includes(slug)) {
      onChange(value.filter((t) => t !== slug));
    } else {
      onChange([...value, slug]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {EVENT_TAGS.map((tag) => {
        const isSelected = value.includes(tag.slug);
        return (
          <button
            key={tag.slug}
            type="button"
            onClick={() => toggleTag(tag.slug)}
            className={cn(
              "px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-200",
              "border outline-none focus-visible:ring-2 focus-visible:ring-ring",
              isSelected
                ? "bg-primary text-primary-foreground border-primary"
                : "bg-card border-border text-muted-foreground hover:border-primary/50 hover:text-foreground"
            )}
          >
            {tag.label}
          </button>
        );
      })}
    </div>
  );
}
